
import { FC } from "react";
import styled from "@emotion/native";

import PayBooks from '@assets/icons/drawer/paybook';

const Container = styled.TouchableOpacity``;

type Props = {
  onPress?: () => void;
};

const PlayBookDrawerLogo: FC<Props> = ({ onPress,...props }) => {
  return (
    <Container onPress={onPress} {...props}>
        <PayBooks />
    </Container>
  );
};

export default PlayBookDrawerLogo;